document.querySelectorAll('media-gallery').forEach((gallery) => {
  const sliderComponent = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
  const slider = sliderComponent?.querySelector('.product__media-list');
  const dots = Array.from(gallery.querySelectorAll('.slider-counter__link--dots'));

  if (!sliderComponent || !slider || !dots.length || sliderComponent.dataset.dotsInitialized) return;
  sliderComponent.dataset.dotsInitialized = 'true';

  const slides = Array.from(slider.querySelectorAll('.product__media-item'));
  const setActiveDot = (index) => {
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('slider-counter__link--active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const slide = slides[Number(dot.dataset.slideIndex)];
      if (!slide) return;
      slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActiveDot(Number(dot.dataset.slideIndex));
    });
  });

  sliderComponent.addEventListener('slideChanged', (event) => {
    setActiveDot(event.detail.currentPage - 1);
  });
});
